import ReactApexChart from "react-apexcharts";
import { getQuarter } from "date-fns"; // Import a date library for working with quarters
import { colorPalette } from "./chartOption";
import { useMediaQuery } from "@mui/material";

interface RecyclingRateQuarterProps {
    quantityPerMonth: Map<string, number>;
}

const RecyclingRateQuarterChart = ({
    quantityPerMonth,
}: RecyclingRateQuarterProps) => {
    const quarterlyData: Map<string, number> = new Map();

    const months = Array.from(quantityPerMonth.keys());

    for (const month of months) {
        const quarter = getQuarter(new Date(month));
        const quantity = quantityPerMonth.get(month);

        if (quantity !== undefined) {
            const key = `Q${quarter}`;
            const currentTotal = quarterlyData.get(key) || 0;
            quarterlyData.set(key, currentTotal + quantity);
        }
    }
    const labels = Array.from(quarterlyData.keys());
    const values = Array.from(quarterlyData.values());

    const chartData = {
        series: values,
    };
    const colors = colorPalette.slice(0, labels.length);

    const chartOptions = {
        legend: {
            position: 'bottom' as "bottom",
            fontSize: '14px',
            fontWeight: 600,
        },
        labels: labels,
        dataLabels: {
            style: {
                fontSize: '14px',
                colors: ['white'],
                
            },
            dropShadow: {
                enabled: true,
                top: 2,
                left: 2,
                blur: 2,
                color: 'black',
                opacity: 1
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "60%"
                }
            }
        },
        fill: {
            colors,
        },
        colors,
        markers: {
            colors,
        },
        title: {
                text: 'Recycling rate by quartile'
              },
    };

    return (
        <div>
            <ReactApexChart
                options={chartOptions}
                series={chartData.series}
                type="donut"
                width="100%"
                height="200%"
            />
        </div>
    );
};

export default RecyclingRateQuarterChart;
